export { default } from './useForkRef';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useForkRef/index.js
// module id = 307
// module chunks = 25